import React, { memo } from 'react';
import { Modal } from 'antd';
import TpListSearch from './TpList';
import { TpList } from '../../services/thirdParty';

export type TpListModalProps = {
  visible: boolean;
  onCancel: () => void;
  onSelect: (item: TpList) => void;
};

const TpListModal = (props: TpListModalProps) => {
  const { visible, onCancel, onSelect } = props;

  return (
    <Modal
      visible={visible}
      title="Search"
      footer={null}
      onCancel={onCancel}
      //width={2000}
      width={1200}
    >
      <TpListSearch onSelect={onSelect} isModal="true" />
    </Modal>
  );
};

export default memo(TpListModal);
